<template>
  <div class="e-block-wrap">
    <div class="e-block">
      <div class="e-block__scroll" :style="{ minHeight: containerHeight }">
        <div class="e-selector-block">
          <div class="e-row e-row--gutters">
            <div class="e-col e-col-sm-12">
              <div class="e-block__title e-block__title--mb16">{{ currentQuestion.title || 'Enter single fixture flow rate' }}</div>
              <div class="e-block__text e-block__text--mb16">{{ currentQuestion.text || 'You can manually enter your flow rate here using the ranges to the right as a guide. It is highly recommended to find the actual flow rate & if it differs, please enter the actual value instead.' }}</div>
              <div>
                <div class="e-block__form-label">{{ currentQuestion.inputLabel || 'Flow Rate (GPM)' }}</div>
                <input type="text"
                       class="e-input"
                       v-model="value"
                       @keypress="isNumber">
              </div>
              <div class="e-input__hint" v-if="currentQuestion.hint" v-html="currentQuestion.hint"></div>
            </div>
            <div class="e-col e-col-sm-12">
              <div v-if="currentQuestion.img">
                <img class="e-fixture__img e-fixture__img--large" :src="currentQuestion.img" alt=""/>
              </div>
              <div class="e-block__form" v-else>
                <div class="e-block__form-label e-block__form-label--grey900">Common household fixtures</div>
                <div class="e-row e-row--gutters24">
                  <div class="e-col-4" v-for="(fixture, index) in fixtures" :key="`fixture-${index}`">
                    <div class="e-fixture">
                      <div class="e-fixture__img" :style="{backgroundImage: `url(${fixture.img})`}" />
                      <div class="e-fixture__title">{{ fixture.title }}</div>
                      <div class="e-fixture__val">{{ fixture.flowRate }}</div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <tip v-if="currentQuestion.tip" :text="currentQuestion.tip" />
        </div>
      </div>
    </div>
    <div class="e-bottom-navbar">
      <div class="e-row e-row--gutters">
        <div class="e-col-auto e-col-sm-6 e-order-sm-2">
          <button class="e-btn e-btn--prev" @click.prevent="previous">Previous</button>
        </div>
        <div class="e-col-auto e-col-sm-6 e-order-sm-3">
          <button class="e-btn e-btn--help e-btn--no-text" @click.prevent="nextQuestion(needHelp)"><span>Help</span></button>
        </div>
        <div class="e-col"></div>
        <div class="e-col-auto e-col-sm-12 e-order-sm-1">
          <button class="e-btn e-btn--next" @click.prevent="proceed(value)" :disabled="disabledBtn">Proceed</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions, mapGetters } from 'vuex';
import { needHelp } from '@/utils/residential-flow';
import Tip from '@/components/ui/Tip.vue';
import { commonFixtures } from '@/store';

export default {
  components: {
    Tip,
  },
  name: 'FlowRate',
  data() {
    return {
      value: 2.5,
      needHelp,
      fixtures: commonFixtures,
    };
  },
  mounted() {
    if (this.currentQuestion.defaultValue) {
      this.value = this.currentQuestion.defaultValue;
    }
    const link = document.querySelector('.e-assistance');
    if (link) {
      link.addEventListener('click', (e) => {
        e.preventDefault();
        this.nextQuestion(needHelp);
      });
    }
  },
  computed: {
    ...mapState(['selectedFlow', 'containerHeight']),
    ...mapGetters(['currentQuestion']),
    disabledBtn() {
      return !this.value || +(this.value) <= 0;
    },
  },
  methods: {
    ...mapActions(['previousQuestion', 'nextQuestion', 'addParamToFilter']),
    previous() {
      this.previousQuestion();
    },
    proceed(value) {
      this.addParamToFilter({ name: this.currentQuestion.paramName, value });
      this.nextQuestion(this.currentQuestion.nextId);
    },
    isNumber(evt) {
      evt = (evt) || window.event;
      const charCode = (evt.which) ? evt.which : evt.keyCode;
      if ((charCode > 31 && (charCode < 48 || charCode > 57)) && charCode !== 46) {
        evt.preventDefault();
        return false;
      }
      return true;
    },
  },
};
</script>

<style lang="scss">

</style>
